"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The default adapter does a direct mapping from pointer events to mouse event handlers. We can modify this to make
 * shared widgets more touch-friendly out of the box.
 */
var DefaultPointerEventAdapter = /** @class */ (function () {
    function DefaultPointerEventAdapter() {
    }
    DefaultPointerEventAdapter.prototype.getHtmlAttributes = function (props) {
        var domEventProps = {
            onDoubleClick: props.pointerDoubleClick ?
                function (event) { if (!props.disabled) {
                    props.pointerDoubleClick(event);
                } } : undefined,
            onMouseDown: props.pointerDown ?
                function (event) { if (!props.disabled) {
                    props.pointerDown(event);
                } } : undefined,
            onMouseUp: props.pointerUp ?
                function (event) { if (!props.disabled) {
                    props.pointerUp(event);
                } } : undefined,
            onClick: props.pointerClick ?
                function (event) { if (!props.disabled) {
                    props.pointerClick(event);
                } } : undefined
        };
        return domEventProps;
    };
    return DefaultPointerEventAdapter;
}());
var PointerEventAdapterManager = /** @class */ (function () {
    function PointerEventAdapterManager() {
    }
    /**
     *  Clients with custom pointer event systems should override the default factory
     */
    PointerEventAdapterManager.adapterFactory = function () { return new DefaultPointerEventAdapter(); };
    return PointerEventAdapterManager;
}());
exports.PointerEventAdapterManager = PointerEventAdapterManager;
//# sourceMappingURL=PointerEventAdapter.js.map